import React from "react";
import { IoMdArrowDropdownCircle } from "react-icons/io";

const DropdownMenus = (props) => {
  const styles = {
    position: "absolute",
    top: 0,
    right: 0,
    height: "100%",
    display: "flex",

    alignItems: "center",
    justifyContent: "center",
    padding: " 0 10px" /* Adjust padding as needed */,
    cursor: "pointer",
  };
  return (
    <div
      style={{
        marginBottom: "15px",
        position: "relative",
        width: "100%",
        height: "30px",
        backgroundColor: "#f0f0f0",
      }}
      className="dropdown-menu_1"
    >
      {/* Content */}
      <div>
        <p style={{ padding: "5px" }}>{props.comments}</p>
      </div>

      {/* Dropdown icon */}
      <div style={styles}>
        <IoMdArrowDropdownCircle />
      </div>
    </div>
  );
};

export default DropdownMenus;
